export const BASE_URL = 'https://technigo-backends.onrender.com/final-project-api/';

export const API_URL = (slug) => `${BASE_URL}${slug}`;
export const API_KEY = '90138b7b14dd18ad14d7fe7a74d94a61';
